import {
    useEffect,
} from 'react'

import {
    useAppSelector,
    useAppDispatch,
} from 'app/store/hooks'
import {
    clearState,
    selectShowArchived,
} from 'app/shared-components/TableControls/store'

// withoutCleanUp- when we use it inside short-lived components, but we need state for table
const useArchivedTableControl = (name: string, withoutCleanUp: boolean = false) => {
    const dispatch = useAppDispatch()

    const showArchived = useAppSelector((state) => {
        return selectShowArchived(state, name)
    })

    useEffect(() => {
        return () => {
            if (!withoutCleanUp) {
                dispatch(clearState(name))
            }
        }
    }, [
        dispatch,
        name,
        withoutCleanUp,
    ])

    return showArchived
}

export default useArchivedTableControl
